const en = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    remove: 'Remove',
    close: 'Close',
    confirm: 'Confirm',
    apply: 'Apply',
    reset: 'Reset',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    update: 'Update',
    refresh: 'Refresh',
    export: 'Export',
    import: 'Import',
    download: 'Download',
    upload: 'Upload',
    print: 'Print',
    copy: 'Copy',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    done: 'Done',
    select: 'Select',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    noResults: 'No results found',
    noData: 'No data available',
    required: 'Required',
    optional: 'Optional',
    actions: 'Actions',
    details: 'Details',
    overview: 'Overview',
    summary: 'Summary',
    total: 'Total',
    all: 'All',
    none: 'None',
    name: 'Name',
    type: 'Type',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    description: 'Description',
    notes: 'Notes',
    comments: 'Comments',
    category: 'Category',
    priority: 'Priority',
    nation: 'Nation',
    country: 'Country',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    location: 'Location',
    coordinates: 'Coordinates',
    latitude: 'Latitude',
    longitude: 'Longitude',
    from: 'From',
    to: 'To',
    createdAt: 'Created',
    updatedAt: 'Updated',
    createdBy: 'Created by',
    modifiedBy: 'Modified by',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    showing: 'Showing',
    of: 'of',
    page: 'Page',
    perPage: 'per page',
    rows: 'rows',
    items: 'items',
    results: 'results',
    sortBy: 'Sort by',
    ascending: 'Ascending',
    descending: 'Descending',
    viewAll: 'View All',
    viewDetails: 'View Details',
    goBack: 'Go Back',
    learnMore: 'Learn More',
    seeMore: 'See More',
    showMore: 'Show More',
    showLess: 'Show Less',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    copied: 'Copied!',
    saved: 'Saved!',
    deleted: 'Deleted!',
    updated: 'Updated!',
    created: 'Created!',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    danger: 'Danger',
    unknown: 'Unknown',
    notAvailable: 'N/A',
    never: 'Never',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    now: 'Now',
    ago: 'ago',
    justNow: 'just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    monthsAgo: '{{count}}mo ago',
    id: 'ID',
    version: 'Version',
    language: 'Language',
    theme: 'Theme',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    failedToLoad: 'Failed to load data',
    failedToSave: 'Failed to save',
    failedToDelete: 'Failed to delete',
    failedToUpdate: 'Failed to update',
    confirmDelete: 'Are you sure you want to delete this?',
    confirmAction: 'Are you sure?',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
    pageNotFound: '404 - Page Not Found',
    pageNotFoundDesc: 'The page you are looking for does not exist.',
    backToDashboard: 'Back to Dashboard',
    characters: 'characters',
    maxCharacters: 'Maximum {{max}} characters',
    remaining: '{{count}} remaining',
    selected: '{{count}} selected',
    of_total: '{{count}} of {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Requests',
    transports: 'Transports',
    missions: 'Missions',
    myPatients: 'My Patients',
    myPatientsTreatment: 'Treatment',
    myPatientsTransport: 'Transport',
    statistics: 'Statistics',
    flow: 'Flow',
    resources: 'Resources',
    exercise: 'Exercise',
    administration: 'Administration',
    map: 'Map',
    info: 'Info',
    users: 'Users',
    assets: 'Assets',
    hubs: 'Hubs',
    treatmentFacilities: 'Treatment Facilities',
    patientImport: 'Patient Import',
    assetTemplates: 'Asset Templates',
    dayTemplates: 'Day Templates',
    announcementTicker: 'Announcement Ticker',
    exerciseStatistics: 'Exercise Statistics',
    settings: 'Settings',
    auditLog: 'Audit Log',
    exerciseControl: 'Exercise Control',
    dataSync: 'Data Sync',
    documentation: 'Documentation',
    support: 'Support',
    about: 'About',
    assetContracts: 'Asset Contracts',
    notifications: 'Notifications',
    schedules: 'Schedules',
    capacityPlanning: 'Capacity Planning',
    transportPlanning: 'Transport Planning',
    transportBooking: 'Transport Booking',
    flowDiagram: 'Flow Diagram',
    changePassword: 'Change Password',
    startPoints: 'Start Points',
    hospital: 'Hospital',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Login',
    logout: 'Logout',
    logoutNow: 'Logout Now',
    loggingIn: 'Logging in...',
    loginFailed: 'Login failed',
    email: 'Email',
    password: 'Password',
    username: 'Username',
    enterEmail: 'Enter your email address',
    enterPassword: 'Enter your password',
    enterUsername: 'Enter your username',
    forgotPassword: 'Forgot password?',
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordDesc: 'Enter your username and email address. If both match, administrators will be notified to reset your password.',
    requestPasswordReset: 'Request Password Reset',
    sending: 'Sending...',
    backToLogin: 'Back to Login',
    pleaseWait: 'Please wait before trying again.',
    requestFailed: 'Request failed',
    credentialsMatch: 'If the credentials match, administrators have been notified.',
    forAccess: 'For access, please contact your system administrator.',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed successfully',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    changingPassword: 'Changing...',
    mustChangePassword: 'You must change your password before continuing.',
    sessionExpiring: 'Session Expiring',
    sessionExpireText: 'Your session will expire in <strong>{{time}}</strong>. Please save your work and log in again to continue.',
    dismiss: 'Dismiss',
    switchNation: 'Switch Nation',
    switchUser: 'Switch User',
    returnTo: 'Return to {{nation}}',
    viewingAs: 'You are viewing as',
    loggedInAs: 'logged in as {{nation}}',
    trainingMode: 'FOR TRAINING PURPOSES ONLY',
    dedication: 'Created with love and dedication to the profession',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'System Admin',
    excon: 'Exercise Controller',
    eu: 'EU Coordinator',
    planner: 'Planner',
    hub: 'Hub Manager',
    nation: 'Nation',
    readOnly: 'Read-Only',
    systemAdmin: 'System Administrator',
    transportPlanner: 'Transport Planner',
    systemRoles: 'System Roles',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Draft',
    underReview: 'Under Review',
    published: 'Published',
    underSelection: 'Under Selection',
    accepted: 'Accepted',
    planned: 'Planned',
    inTransit: 'In Transit',
    completed: 'Completed',
    closed: 'Closed',
    withdrawn: 'Withdrawn',
    pending: 'Pending',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    active: 'Active',
    inactive: 'Inactive',
    review: 'Review',
    selection: 'Selection',
    transit: 'Transit',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personnel',
    material: 'Material',
    equipment: 'Equipment',
    other: 'Other',
    news: 'News',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Routine',
    priority: 'Priority',
    urgent: 'Urgent',
    immediate: 'Immediate',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Train',
    ship: 'Ship',
    aircraft: 'Aircraft',
    bus: 'Bus',
    ambulance: 'Ambulance',
    drone: 'Drone',
    helicopter: 'Helicopter',
    ferry: 'Ferry',
    other: 'Other',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Good morning',
    goodAfternoon: 'Good afternoon',
    goodEvening: 'Good evening',
    lastLogin: 'Last login',
    infrastructure: 'Infrastructure',
    transportAssets: 'Transport Assets',
    treatmentFacilities: 'Treatment Facilities',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Request Statistics',
    viewAllRequests: 'View all requests',
    availableAssets: 'Available Assets',
    seated: 'Seated',
    lying: 'Lying',
    intensive: 'Intensive',
    notifications: 'Notifications',
    markAllRead: 'Mark all read',
    noNotifications: 'No notifications yet',
    notifiedWhenActivity: 'You will be notified when new activity occurs',
    viewDetailsBtn: 'View Details',
    nationUsers: 'Nation Users',
    user: 'User',
    roles: 'Roles',
    noUsersFound: 'No users found',
    participatingNations: 'Participating Nations',
    exerciseDisclaimer: 'This system is for exercise use only. Enter simulated exercise data exclusively. Workflows are adapted to the exercise scenario and may differ from real-world procedures. IT security and data protection rules remain fully applicable.',
    notConfigured: 'Not configured',
    requestCount: '{{count}} request(s)',
    clickToView: 'Click to view',
    systemAdministration: 'System Administration',
    exerciseControlTitle: 'Exercise Control',
    euCoordination: 'EU Coordination',
    transportPlanningTitle: 'Transport Planning',
    hubManagement: 'Hub Management',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'New Request',
    myDrafts: 'My Drafts',
    pendingReview: 'Pending Review',
    activeTransports: 'Active Transports',
    myPatients: 'My Patients',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Requests',
    newRequest: 'New Request',
    createRequest: 'Create Request',
    editRequest: 'Edit Request',
    requestDetail: 'Request Detail',
    requestId: 'Request ID',
    fromNation: 'From Nation',
    toNation: 'To Nation',
    requestingNation: 'Requesting Nation',
    receivingNation: 'Receiving Nation',
    category: 'Category',
    urgency: 'Urgency',
    status: 'Status',
    patients: 'Patients',
    patientCount: 'Patient Count',
    offers: 'Offers',
    offerCount: 'Offer Count',
    created: 'Created',
    updated: 'Updated',
    submittedBy: 'Submitted by',
    reviewedBy: 'Reviewed by',
    description: 'Description',
    medicalDetails: 'Medical Details',
    transportDetails: 'Transport Details',
    additionalInfo: 'Additional Information',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Departure Point',
    arrivalPoint: 'Arrival Point',
    estimatedDeparture: 'Estimated Departure',
    estimatedArrival: 'Estimated Arrival',
    submitForReview: 'Submit for Review',
    publish: 'Publish',
    startSelection: 'Start Selection',
    acceptOffer: 'Accept Offer',
    markInTransit: 'Mark In Transit',
    markCompleted: 'Mark Completed',
    closeRequest: 'Close Request',
    withdrawRequest: 'Withdraw Request',
    withdraw: 'Withdraw',
    revertToDraft: 'Revert to Draft',
    deleteRequest: 'Delete Request',
    duplicateRequest: 'Duplicate Request',
    createFollowUp: 'Create Consolidated Request',
    followUpRequest: 'Consolidated Request',
    parentRequest: 'Original Request',
    childRequests: 'Consolidated Requests',
    noRequests: 'No requests found',
    noOffers: 'No offers yet',
    addPatient: 'Add Patient',
    removePatient: 'Remove Patient',
    patientDetails: 'Patient Details',
    contactPerson: 'Contact Person',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    specialRequirements: 'Special Requirements',
    medicalEquipment: 'Medical Equipment',
    accompaniment: 'Accompaniment',
    timeline: 'Timeline',
    history: 'History',
    addComment: 'Add Comment',
    writeComment: 'Write a comment...',
    postComment: 'Post Comment',
    posting: 'Posting...',
    noComments: 'No comments yet',
    coverageBar: 'Coverage',
    covered: 'covered',
    uncovered: 'uncovered',
    filterByStatus: 'Filter by status',
    filterByCategory: 'Filter by category',
    filterByNation: 'Filter by nation',
    searchRequests: 'Search requests...',
    confirmWithdraw: 'Are you sure you want to withdraw this request?',
    confirmDelete: 'Are you sure you want to delete this request?',
    confirmPublish: 'Are you sure you want to publish this request? It will be visible to all nations.',
    confirmStartSelection: 'Are you sure you want to start selection? Nations will be able to make offers.',
    warningStartSelection: 'Starting selection will make this request visible to all participating nations. They will be able to submit offers for the patients in this request. This action cannot be undone.',
    warningMakeOffer: 'By submitting this offer, you commit your nation to providing the proposed assistance. This action will notify the requesting nation and exercise control.',
    saveDraft: 'Save Draft',
    saving: 'Saving...',
    saveAndSubmit: 'Save & Submit',
    step: 'Step {{number}}',
    generalInfo: 'General Information',
    patientInfo: 'Patient Information',
    logisticsInfo: 'Logistics Information',
    reviewSubmit: 'Review & Submit',
    requestTitle: 'Request Title',
    requestDescription: 'Request Description',
    numberOfPatients: 'Number of Patients',
    typeOfAssistance: 'Type of Assistance',
    medicalTreatment: 'Medical Treatment',
    transportAssistance: 'Transport Assistance',
    both: 'Both',
    treatmentOnly: 'Treatment Only',
    transportOnly: 'Transport Only',
    missingTransport: 'Missing transport',
    noOffersReceived: 'No offers',
    validationErrors: 'Please fix the following errors:',
    fieldRequired: 'This field is required',
    selectExitHub: 'Select an exit hub',
    createExitHub: 'Create Exit Hub',
    backToRequests: 'Back to Requests',
    noRequestsFound: 'No requests found',
    createFirstRequest: 'Create your first request to get started',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Offers',
    createOffer: 'Create Offer',
    makeOffer: 'Make Offer',
    manageOffers: 'Manage Offers',
    offerDetail: 'Offer Detail',
    offerId: 'Offer ID',
    offeringNation: 'Offering Nation',
    offerType: 'Offer Type',
    treatment: 'Treatment',
    transport: 'Transport',
    combined: 'Combined',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Treatment Offer',
    transportOffer: 'Transport Offer',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Select Patients',
    selectedPatients: 'Selected Patients',
    patientSelection: 'Patient Selection',
    offerConfiguration: 'Offer Configuration',
    reviewOffer: 'Review Offer',
    submitOffer: 'Submit Offer',
    submitting: 'Submitting...',
    acceptOffer: 'Accept Offer',
    rejectOffer: 'Reject Offer',
    withdrawOffer: 'Withdraw Offer',
    noOffers: 'No offers available',
    noOffer: 'No Offer',
    offerStatus: 'Offer Status',
    offerDate: 'Offer Date',
    transportAsset: 'Transport Asset',
    departureDate: 'Departure Date',
    arrivalDate: 'Arrival Date',
    treatmentFacility: 'Treatment Facility',
    capacity: 'Capacity',
    availableCapacity: 'Available Capacity',
    totalCapacity: 'Total Capacity',
    selectAsset: 'Select Asset',
    selectFacility: 'Select Facility',
    offerNotes: 'Offer Notes',
    confirmAccept: 'Are you sure you want to accept this offer?',
    confirmReject: 'Are you sure you want to reject this offer?',
    extendTransport: 'Extend Transport',
    transportExtension: 'Transport Extension',
    comparisonView: 'Comparison View',
    shortlist: 'Shortlist',
    hideLockedPatients: 'Hide patients already selected in other offers',
    addToShortlist: 'Add to Shortlist',
    removeFromShortlist: 'Remove from Shortlist',
    leaveConfirmTitle: 'Leave this page?',
    leaveConfirmMessage: 'You have unsaved changes. Are you sure you want to leave?',
    stayOnPage: 'Stay on Page',
    leavePage: 'Leave Page',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transports',
    missionDetail: 'Transport Detail',
    missionId: 'Transport ID',
    missionStatus: 'Transport Status',
    createMission: 'Create Transport',
    overview: 'Overview',
    patientsTab: 'Patients',
    transportsTab: 'Transport Legs',
    treatmentTab: 'Treatment',
    reviewTab: 'Review',
    departure: 'Departure',
    arrival: 'Arrival',
    origin: 'Origin',
    destination: 'Destination',
    stops: 'Stops',
    addStop: 'Add Stop',
    removeStop: 'Remove Stop',
    stopName: 'Stop Name',
    stopType: 'Stop Type',
    estimatedTime: 'Estimated Time',
    actualTime: 'Actual Time',
    asset: 'Asset',
    driver: 'Driver',
    crew: 'Crew',
    noMissions: 'No transports found',
    completeMission: 'Complete Transport',
    cancelMission: 'Cancel Transport',
    startTransport: 'Start Transport',
    missionChain: 'Transport Chain',
    linkedMissions: 'Linked Transports',
    handover: 'Handover',
    handoverPoint: 'Handover Point',
    pickupPoint: 'Pickup Point',
    dropoffPoint: 'Drop-off Point',
    searchTransports: 'Search transports...',
    readyAtHub: 'Ready at Hub',
    noAsset: 'No asset',
    deleteTransport: 'Delete transport',
    moveUp: 'Move up',
    moveDown: 'Move down',
    patientsReady: 'Patients ready',
    assetArrives: 'Asset arrives',
    selectDateTime: 'Select date & time',
    notSet: 'Not set',
    transportDescription: 'Each transport represents one vehicle journey from the Transit Hub to an Exit Hub.',
    arrived: 'arrived',
    overdue: 'overdue',
    inTime: 'in',
    speed: 'Speed',
    noStops: 'No route stops configured for this mission.',
    completedSegment: 'Completed',
    pendingSegment: 'Pending',
    calculateEta: 'Calculate ETA',
    // Transport Planning Step
    transportPlanning: 'Transport Planning',
    patientsTotal: 'patients total',
    patientsAssigned: 'assigned',
    patientsRemaining: 'remaining',
    availableAssets: 'Available Assets',
    assetAvailable: 'Available',
    assetBusy: 'Busy',
    assetBusyUntil: 'Busy until',
    routeConfig: 'Route Configuration',
    startPoint: 'Start Point (Transit Hub)',
    exitHubSelect: 'Exit Hub (Destination)',
    exitHubHint: 'Your nation controls this route',
    groupBy: 'Group by',
    groupByPriority: 'Priority',
    groupByDependency: 'Dependency',
    groupByMobility: 'Mobility',
    groupByNone: 'None',
    dragPatientsHint: 'Drag patients to assign them to a trip',
    trips: 'Trips',
    addTrip: 'Add Trip',
    returnTrip: 'Return Trip',
    tripDeparture: 'Departure',
    tripArrival: 'Arrival',
    capacityUsed: 'capacity used',
    atCapacity: 'At capacity',
    overCapacity: 'Over capacity',
    seatsUsed: 'seats used',
    scheduleReturn: 'Schedule return trip with same asset',
    selectAssetFirst: 'Select an asset first',
    noTripsYet: 'No trips planned yet. Create a trip to start assigning patients.',
    seated: 'Seated',
    lying: 'Lying',
    intensive: 'Intensive',
    turnaroundTime: 'Turnaround time',
    saveAndContinue: 'Save & Continue',
    capacityWarning80: 'Approaching capacity ({{pct}}%)',
    capacityWarning100: 'At maximum capacity',
    capacityOverflow: '{{pct}}% overflow (20% tolerance)',
    capacityBlocked: 'Exceeds 20% overflow tolerance',
    unassignedPatients: 'Unassigned',
    patientsSelected: 'selected',
    startPointNote: 'Fixed by hosting nation',
    treatmentDestination: 'Treatment Destinations',
    otherPoints: 'Other Points',
    dropPatientsHere: 'Drop patients here',
    tripFull: 'This trip is at capacity.',
    assetSelected: 'Asset selected — click Add Trip',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patients',
    myPatients: 'My Patients',
    patientId: 'Patient ID',
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    age: 'Age',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    nationality: 'Nationality',
    diagnosis: 'Diagnosis',
    condition: 'Condition',
    dependency: 'Dependency',
    stable: 'Stable',
    critical: 'Critical',
    serious: 'Serious',
    treatmentNeeded: 'Treatment Needed',
    allergies: 'Allergies',
    medications: 'Medications',
    bloodType: 'Blood Type',
    weight: 'Weight (kg)',
    infectious: 'Infectious',
    mentalHealth: 'Mental Health',
    mobility: 'Mobility',
    ambulatory: 'Ambulatory',
    wheelchair: 'Wheelchair',
    stretcher: 'Stretcher',
    intensive: 'Intensive Care',
    oxygenRequired: 'Oxygen Required',
    ventilator: 'Ventilator',
    medicalEscort: 'Medical Escort',
    noPatients: 'No patients found',
    patientDetails: 'Patient Details',
    medicalHistory: 'Medical History',
    travelDocuments: 'Travel Documents',
    passport: 'Passport',
    pseudonymizedId: 'Pseudonymized ID',
    sensitiveData: 'Sensitive Data',
    journey: 'Patient Journey',
    assignedTo: 'Assigned to',
    currentLocation: 'Current Location',
    importPatients: 'Import Patients',
    exportPatients: 'Export Patients',
    seated: 'Seated',
    lying: 'Lying',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Users',
    createUser: 'Create User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    username: 'Username',
    displayName: 'Display Name',
    email: 'Email',
    password: 'Password',
    role: 'Role',
    roles: 'Roles',
    nation: 'Nation',
    active: 'Active',
    lastLogin: 'Last Login',
    createdAt: 'Created',
    isNation: 'Nation',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planner',
    isHub: 'Hub',
    isReadOnly: 'Read-Only',
    noUsers: 'No users found',
    confirmDelete: 'Are you sure you want to delete this user?',
    resetPassword: 'Reset Password',
    generatePassword: 'Generate Password',
    searchUsers: 'Search users...',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    selectNation: 'Select a nation',
    mustChangePassword: 'Must change password on next login',
    flagImage: 'Flag Image',
    exportUsers: 'Export Users',
    importUsers: 'Import Users',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Assets',
    createAsset: 'Create Asset',
    editAsset: 'Edit Asset',
    deleteAsset: 'Delete Asset',
    assetName: 'Asset Name',
    assetType: 'Asset Type',
    capacitySeated: 'Capacity (Seated)',
    capacityLying: 'Capacity (Lying)',
    capacityIntensive: 'Capacity (Intensive)',
    owner: 'Owner',
    operator: 'Operator',
    baseLocation: 'Base Location',
    range: 'Range',
    speed: 'Speed',
    noAssets: 'No assets found',
    confirmDelete: 'Are you sure you want to delete this asset?',
    searchAssets: 'Search assets...',
    assetCreated: 'Asset created successfully',
    assetUpdated: 'Asset updated successfully',
    assetDeleted: 'Asset deleted successfully',
    exportAssets: 'Export Assets',
    // Asset group labels
    aircraft: 'Aircraft',
    helicopter: 'Helicopter',
    ground: 'Ground',
    sea: 'Sea',
    busy: 'Busy',
    available: 'Available',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Start Points',
    createHub: 'Create Hub',
    editHub: 'Edit Hub',
    deleteHub: 'Delete Hub',
    hubName: 'Hub Name',
    hubType: 'Hub Type',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Entry Hub',
    airport: 'Airport',
    seaport: 'Seaport',
    railStation: 'Rail Station',
    roadPoint: 'Road Point',
    ucpmClassification: 'UCPM Classification',
    icaoCode: 'ICAO Code',
    iataCode: 'IATA Code',
    noHubs: 'No hubs found',
    confirmDelete: 'Are you sure you want to delete this hub?',
    searchHubs: 'Search hubs...',
    nationAssignment: 'Nation Assignment',
    assignNations: 'Assign Nations',
    availableNations: 'Available Nations',
    assignedNations: 'Assigned Nations',
    originNationHint: 'The nation in which the hub is located ({{nation}}) automatically has access.',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Treatment Facilities',
    createFacility: 'Create Facility',
    editFacility: 'Edit Facility',
    deleteFacility: 'Delete Facility',
    facilityName: 'Facility Name',
    facilityType: 'Facility Type',
    hospitalName: 'Hospital Name',
    bedCapacity: 'Bed Capacity',
    specialties: 'Specialties',
    availableBeds: 'Available Beds',
    totalBeds: 'Total Beds',
    contactPerson: 'Contact Person',
    noFacilities: 'No treatment facilities found',
    confirmDelete: 'Are you sure you want to delete this facility?',
    searchFacilities: 'Search facilities...',
    hubNationAssignment: 'Hub Nation Assignment',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Schedules',
    createSchedule: 'Create Schedule',
    editSchedule: 'Edit Schedule',
    deleteSchedule: 'Delete Schedule',
    scheduleName: 'Schedule Name',
    scheduleType: 'Schedule Type',
    recurring: 'Recurring',
    oneTime: 'One-time',
    frequency: 'Frequency',
    daily: 'Daily',
    weekly: 'Weekly',
    startDate: 'Start Date',
    endDate: 'End Date',
    departureTime: 'Departure Time',
    arrivalTime: 'Arrival Time',
    stops: 'Stops',
    addStop: 'Add Stop',
    noSchedules: 'No schedules found',
    bookings: 'Bookings',
    timeline: 'Timeline',
    reorderHint: 'Drag and drop stops to reorder the route',
    segment: 'Segment',
    available: 'available',
    totalUtilization: 'Total Utilization',
    route: 'Route',
    bookedBy: 'Booked by',
    leaveEmptyFirstStop: 'leave empty for first stop',
    leaveEmptyLastStop: 'leave empty for last stop',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all read',
    markAsRead: 'Mark as read',
    markAsUnread: 'Mark as unread',
    noNotifications: 'No notifications',
    viewAll: 'View All Notifications',
    settings: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    inAppNotifications: 'In-App Notifications',
    notifyOn: 'Notify me about',
    requestCreated: 'New Request',
    requestPublished: 'Request Published',
    requestClosed: 'Request Closed',
    requestCompleted: 'Request Completed',
    commentAdded: 'New Comment',
    offerReceived: 'Offer Received',
    offerAccepted: 'Offer Accepted',
    statusChanged: 'Status Changed',
    selectionStarted: 'Selection Started',
    missionCreated: 'Transport Created',
    missionStatusUpdated: 'Transport Updated',
    transportPartnerNamed: 'Transport Partner',
    transportExtensionReceived: 'Transport Extension',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Settings',
    general: 'General',
    system: 'System',
    email: 'Email',
    sync: 'Sync',
    security: 'Security',
    appearance: 'Appearance',
    systemName: 'System Name',
    systemEmail: 'System Email',
    maintenanceMode: 'Maintenance Mode',
    readOnlyMode: 'Read-Only Mode',
    emailEnabled: 'Email Enabled',
    smtpHost: 'SMTP Host',
    smtpPort: 'SMTP Port',
    smtpUser: 'SMTP User',
    smtpPassword: 'SMTP Password',
    senderEmail: 'Sender Email',
    senderName: 'Sender Name',
    testEmail: 'Send Test Email',
    syncEnabled: 'Sync Enabled',
    syncUrl: 'Sync URL',
    syncApiKey: 'Sync API Key',
    settingsSaved: 'Settings saved successfully',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesk Title',
    helpdeskEmail: 'Helpdesk Email',
    helpdeskPhone: 'Helpdesk Phone',
    helpdeskInfo: 'Helpdesk Info',
    realLifeSupport: 'Real Life Support',
    trainingMode: 'Training Mode',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Audit Logs',
    action: 'Action',
    user: 'User',
    target: 'Target',
    details: 'Details',
    timestamp: 'Timestamp',
    ipAddress: 'IP Address',
    noLogs: 'No audit logs found',
    searchLogs: 'Search logs...',
    filterByAction: 'Filter by action',
    filterByUser: 'Filter by user',
    exportLogs: 'Export Logs',
    exportCsv: 'Export CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Exercise Control',
    currentDay: 'Current Day',
    exerciseDay: 'Exercise Day',
    nextDay: 'Next Day',
    previousDay: 'Previous Day',
    resetExercise: 'Reset Exercise',
    startExercise: 'Start Exercise',
    endExercise: 'End Exercise',
    dayReset: 'Day Reset',
    confirmReset: 'Are you sure you want to reset the exercise day? This will clear all data for the current day.',
    resetInProgress: 'Reset in progress...',
    maintenanceMode: 'Maintenance Mode',
    enableMaintenance: 'Enable Maintenance',
    disableMaintenance: 'Disable Maintenance',
    mergeImport: 'Merge Import',
    mergeImportDescription: 'Import template assets into the current state without deleting existing requests, offers, or missions. Assets are added alongside existing ones.',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Data Sync',
    syncStatus: 'Sync Status',
    lastSync: 'Last Sync',
    pendingItems: 'Pending Items',
    syncNow: 'Sync Now',
    syncing: 'Syncing...',
    syncSuccess: 'Sync completed successfully',
    syncFailed: 'Sync failed',
    outbox: 'Outbox',
    inbox: 'Inbox',
    configuration: 'Configuration',
    targetUrl: 'Target URL',
    apiKey: 'API Key',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Map',
    layers: 'Layers',
    requests: 'Requests',
    hubs: 'Hubs',
    facilities: 'Facilities',
    routes: 'Routes',
    showAll: 'Show All',
    hideAll: 'Hide All',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    resetView: 'Reset View',
    satellite: 'Satellite',
    terrain: 'Terrain',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Map tiles are served locally',
    tilesOnline: 'Map tiles are loaded from online servers',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistics',
    overview: 'Overview',
    requestsByStatus: 'Requests by Status',
    requestsByCategory: 'Requests by Category',
    requestsByNation: 'Requests by Nation',
    offersByStatus: 'Offers by Status',
    patientsByCondition: 'Patients by Condition',
    transportsByStatus: 'Transports by Status',
    timeline: 'Timeline',
    totalRequests: 'Total Requests',
    totalOffers: 'Total Offers',
    totalPatients: 'Total Patients',
    totalTransports: 'Total Transports',
    averageResponseTime: 'Average Response Time',
    completionRate: 'Completion Rate',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Exercise Statistics',
    overview: 'Overview',
    byCategory: 'By Category',
    byNation: 'By Nation',
    byDay: 'By Day',
    totalPatientsMoved: 'Total Patients Moved',
    totalRequestsProcessed: 'Total Requests Processed',
    averageProcessingTime: 'Average Processing Time',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Flow Diagram',
    sankey: 'Sankey',
    nodeGraph: 'Node Graph',
    refresh: 'Refresh',
    noData: 'No flow data available',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'About',
    version: 'Version',
    systemInfo: 'System Information',
    buildDate: 'Build Date',
    environment: 'Environment',
    description: 'ARCOS — Advanced Request Communication System',
    subtitle: 'Casualty Assistance & Medical Operations',
    whatIsArcos: 'What is ARCOS? – Explanation for Exercise Participants',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Facilitated by MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – where curiosity meets collaboration.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentation',
    gettingStarted: 'Getting Started',
    userGuide: 'User Guide',
    faq: 'FAQ',
    troubleshooting: 'Troubleshooting',
    apiReference: 'API Reference',
    downloadTemplate: 'Download Template',
    overviewDesc: 'CAMO26 (Civil-Military Assistance Medical Operations 2026) is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patient Import',
    uploadFile: 'Upload File',
    selectFile: 'Select File',
    preview: 'Preview',
    importNow: 'Import Now',
    importing: 'Importing...',
    importSuccess: '{{count}} patients imported successfully',
    importFailed: 'Import failed',
    downloadTemplate: 'Download Template',
    dragDrop: 'Drag and drop a file here, or click to select',
    supportedFormats: 'Supported formats: XLSX, XLS, CSV',
    rowsFound: '{{count}} rows found',
    validRows: '{{count}} valid rows',
    invalidRows: '{{count}} invalid rows',
    duplicateRows: '{{count}} duplicate rows',
    previewData: 'Preview Data',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transport Planning',
    planRoute: 'Plan Route',
    routeBuilder: 'Route Builder',
    addWaypoint: 'Add Waypoint',
    removeWaypoint: 'Remove Waypoint',
    estimatedDuration: 'Estimated Duration',
    distance: 'Distance',
    selectVehicle: 'Select Vehicle',
    unsavedChanges: 'You have unsaved changes to your transport plans. Save before leaving?',
  },

  transportBooking: {
    title: 'Transport Booking',
    bookTransport: 'Book Transport',
    availableSlots: 'Available Slots',
    bookingConfirmed: 'Booking Confirmed',
    cancelBooking: 'Cancel Booking',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Capacity Planning',
    totalCapacity: 'Total Capacity',
    usedCapacity: 'Used Capacity',
    availableCapacity: 'Available Capacity',
    utilizationRate: 'Utilization Rate',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Asset Templates',
    dayTemplates: 'Day Templates',
    createTemplate: 'Create Template',
    editTemplate: 'Edit Template',
    deleteTemplate: 'Delete Template',
    templateName: 'Template Name',
    applyTemplate: 'Apply Template',
    noTemplates: 'No templates found',
    confirmDelete: 'Are you sure you want to delete this template?',
    confirmApply: 'Are you sure you want to apply this template? This will overwrite existing data.',
    exportTemplates: 'Export Templates',
    permissions: 'Nation Permissions',
    permissionsHint: 'Control which nations can create assets for each day template',
    permissionsSaved: 'Permissions saved successfully',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Announcement Ticker',
    createAnnouncement: 'Create Announcement',
    editAnnouncement: 'Edit Announcement',
    deleteAnnouncement: 'Delete Announcement',
    message: 'Message',
    startTime: 'Start Time',
    endTime: 'End Time',
    active: 'Active',
    noAnnouncements: 'No announcements',
    confirmDelete: 'Are you sure you want to delete this announcement?',
  },

  // ============================================================
  // ASSET CONTRACTS
  // ============================================================
  contracts: {
    title: 'Asset Contracts',
    subtitle: 'Manage cross-nation asset sharing agreements',
    createContract: 'Create Contract',
    editContract: 'Edit Contract',
    providerNation: 'Provider Nation',
    consumerNation: 'Consumer Nation',
    assetTypes: 'Asset Types',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    expired: 'Expired',
    utcHint: 'Times are in UTC',
    descriptionPlaceholder: 'Additional details about this contract...',
    confirmDelete: 'Delete this contract? This cannot be undone.',
    contractCreated: 'Contract created successfully',
    contractUpdated: 'Contract updated successfully',
    contractDeleted: 'Contract deleted successfully',
    sameNationError: 'Provider and consumer nations must be different',
    selectAtLeastOneType: 'Please select at least one asset type',
    noContracts: 'No contracts found',
    noContractsYet: 'No asset contracts have been created yet.',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Search...',
      noResults: 'No results found',
      showing: 'Showing {{from}} to {{to}} of {{total}}',
      rowsPerPage: 'Rows per page',
      previousPage: 'Previous page',
      nextPage: 'Next page',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Unsaved Changes',
      message: 'You have unsaved changes. Are you sure you want to leave this page?',
      stay: 'Stay on Page',
      leave: 'Leave Page',
    },
    // EmptyState
    emptyState: {
      noData: 'No data available',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Something went wrong',
      message: 'An unexpected error occurred. Please try refreshing the page.',
      retry: 'Retry',
    },
    // ExportButton
    exportButton: {
      export: 'Export',
      exporting: 'Exporting...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Print',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Draft',
      review: 'Review',
      published: 'Published',
      selection: 'Selection',
      inTransit: 'In Transit',
      completed: 'Completed',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online Instance',
      message: 'Read-only mode. Data is synchronized from the primary server.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'You are viewing as',
      loggedInAs: 'logged in as {{nation}}',
      returnTo: 'Return to {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Search pages, requests, transports...',
      searching: 'Searching...',
      noResults: 'No results for "{{query}}"',
      navigate: 'Navigate',
      select: 'Select',
      close: 'Close',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Requests',
        transports: 'Transports',
        map: 'Map',
        myPatients: 'My Patients',
        flowDiagram: 'Flow Diagram',
        statistics: 'Statistics',
        assets: 'Assets',
        startPoints: 'Start Points / Hubs',
        treatmentFacilities: 'Treatment Facilities',
        users: 'Users',
        settings: 'Settings',
        auditLogs: 'Audit Logs',
        exerciseControl: 'Exercise Control',
        dataSync: 'Data Sync',
        patientImport: 'Patient Import',
        notifications: 'Notifications',
        documentation: 'Documentation',
      },
      actions: {
        // Imports
        importPatientsJson: 'Import Patients (JSON)',
        importPatientsExcel: 'Import Patients (Excel)',
        importUsers: 'Import Users (Excel)',
        importAssetTemplates: 'Import Asset Templates (Excel)',
        importDayTemplates: 'Import Day Template Entries (Excel)',
        // Exports
        exportRequests: 'Export Requests (Excel)',
        exportPatients: 'Export Patients (Excel)',
        exportUsers: 'Export Users (Excel)',
        exportCredentials: 'Export Credentials (PDF)',
        exportAuditExcel: 'Export Audit Logs (Excel)',
        exportAuditPdf: 'Export Audit Logs (PDF)',
        // Page context subtitles
        pagePatientImport: 'Patient Import page',
        pageRequestDetail: 'Request Detail page',
        pageUsers: 'User Management page',
        pageAssetTemplates: 'Asset Templates page',
        pageDayTemplates: 'Day Templates page',
        pageRequests: 'Requests List page',
        pageAuditLogs: 'Audit Logs page',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Session Expiring',
      message: 'Your session will expire in <strong>{{time}}</strong>. Please save your work and log in again to continue.',
      dismiss: 'Dismiss',
      logoutNow: 'Logout Now',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Select 4 time zones',
      configure: 'Configure time zones',
      reset: 'Reset',
      apply: 'Apply',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Pick Location',
      latitude: 'Latitude',
      longitude: 'Longitude',
      clickToSelect: 'Click on the map to select a location',
    },
    // Modal
    modal: {
      close: 'Close',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Home',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'System Maintenance',
    message: 'The system is being reset for the next exercise day. Please wait until the process is complete.',
    autoRefresh: 'This page will automatically refresh when the system is available again.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'At least 10 characters',
    uppercase: '1 uppercase letter',
    lowercase: '1 lowercase letter',
    digit: '1 digit',
    special: '1 special character',
  },
};

export default en;
